export default {
  DEFAULT_LOCALE: 'es-ES'
}
